/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from "react";
import Header from "./header";
import PreviewSection from "./timedAuction/PreviewSection";
import SetupSection from "./timedAuction/SetUpLot";
import { dataService } from "../../../services/dataService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LiveLotPreview from "./liveAuction/LiveLotPreview";
import LiveLotSetup from "./liveAuction/LiveLotSetup";
import { Triangle } from "react-loader-spinner";
import { Storage } from "aws-amplify";
import uuid from 'react-uuid';
import { convertToWebP } from "../../../CommonComponent/convertToWebp";
import { sanitizeFileName } from "../../../utils/sanitizeFileName";
import ExitModal from "./ExitModal";
import { getOrphanedDescriptionImageKeys, getDescriptionImageUrls, getQuillModules } from "../../../config/quill";
import config from "../../../config";

export default function CreateLot({edit}){

    const [priceError,setPriceError]=useState(false);
    const [loading,setLoading]=useState(false);
    const Navigate=useNavigate();
    const { id,lotNumber ,uid}=useParams();
    const email = localStorage.getItem('user')
    const location=useLocation();
    const auctionData = location.state?.auction;
    const [isBanner, setIsBanner] = useState(true);
    const [loadLots, setLoadLots] = useState(edit ? true : false);
    const [successToastMessage, setSuccessToastMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [openExitModal, setOpenExitModal] = useState(false);
    const [lotNavigation, setLotNavigation] = useState({ prev: null, next: null });
    
    // Local image storage for preview
    const [localImages, setLocalImages] = useState([]);
    
    // Track old S3 images that need to be deleted when replaced
    const [oldS3Images, setOldS3Images] = useState([]);
    const [lotData, setLotData] = useState(
        {
            auction_id: uid,
            seller_email : email,
            title1: "",
            title2: "",
            description: "",
            ...(auctionData?.auction_type==="live" ? { reserve: "" } : { starting_price: "" }),
            low_estimate: "",
            high_estimate: "",
            shipping_details: "",
            current_bid: 0,
            tags: [],
            images: [],
        }
    )
    const [originalLotData, setOriginalLotData] = useState({
        auction_id: uid,
        seller_email : email,
        title1: "",
        title2: "",
        description: "",
        ...(auctionData?.auction_type==="live" ? { reserve: "" } : { starting_price: "" }),
        low_estimate: "",
        high_estimate: "",
        shipping_details: "",
        current_bid: 0,
        tags: [],
        images: [],
    });
    const [text,setText] = useState('');
    const [descriptionUploading, setDescriptionUploading] = useState(false);
    const [descriptionImageError, setDescriptionImageError] = useState('');
    const imageTrackerRef = useRef([]);
    const quillModules = useRef(getQuillModules(imageTrackerRef, setDescriptionUploading, (msg) => { setDescriptionImageError(msg); setTimeout(() => setDescriptionImageError(''), 5000); }));

    const hasChanges = () => {
        if (!originalLotData) return false;
        
        const fieldsToCompare = ['title1', 'title2', 'description', 'low_estimate', 'high_estimate', 'shipping_details', 'tags'];
        if (auctionData?.auction_type === 'live') {
            fieldsToCompare.push('reserve');
        } else {
            fieldsToCompare.push('starting_price');
        }
        
        // Check basic fields
        for (const field of fieldsToCompare) {
            if (field === 'tags') {
                if (JSON.stringify(lotData[field]) !== JSON.stringify(originalLotData[field])) {
                    return true;
                }
            } else if (field === 'description') {
                const lotDesc = lotData[field].replace(/<\/?p>/g, '');
                const origDesc = originalLotData[field].replace(/<\/?p>/g, '');
                if (lotDesc !== origDesc) {
                    return true;
                }
            } else if (lotData[field] !== originalLotData[field]) {
                return true;
            }
        }
        
        // Check images
        if (lotData.images.length !== originalLotData.images.length) {
            return true;
        }
        
        for (let i = 0; i < lotData.images.length; i++) {
            if (JSON.stringify(lotData.images[i]) !== JSON.stringify(originalLotData.images[i])) {
                return true;
            }
        }
        
        return false;
    };

    const hasChangesRef = useRef(false);

    useEffect(() => {
        hasChangesRef.current = hasChanges();
    }, [lotData, originalLotData]);

    useEffect(() => {
        window.history.pushState({ blocked: true }, '', window.location.href);
    }, []);

    useEffect(() => {
        const handlePopState = () => {
            if (!hasChangesRef.current) {
                window.history.back(); // allow navigation
                return;
            }

            setOpenExitModal('back');

            // Re-insert the blocking state so user stays
            window.history.pushState({ blocked: true }, '', window.location.href);
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, []);

    const getLotDetails = async() =>{
        const response = await dataService.ViewLot(auctionData.auction_id, lotNumber);
        if(response.error){
            Navigate(-1)
        }else{
            const lot = response.data.data;
            const lotDataObj = {
                auction_id: lot.auction_id || '',
                seller_email : lot.seller_email || '',
                title1: lot.title1 || '',
                title2: lot.title2 || '',
                description: lot.description || '',
                ...(auctionData?.auction_type==="live" ? 
                    { reserve: lot.reserve || '' } : 
                    { starting_price: lot.starting_price || '' }),
                low_estimate: lot.high_estimate!==0 ? lot.low_estimate : '',
                high_estimate: lot.high_estimate || '',
                shipping_details: lot.shipping_details || '',
                current_bid: lot.current_bid,
                tags: lot.tags || [],
                images: lot.images || [],
            }
            setLotData(lotDataObj);
            setLotNavigation({ prev: response.data.prev_lot_number ?? null, next: response.data.next_lot_number ?? null });
            setOriginalLotData(JSON.parse(JSON.stringify(lotDataObj)));
            setText(lot.description);
            imageTrackerRef.current.push(...getDescriptionImageUrls(lot.description));
            setLoadLots(false);
        }
    }

    useEffect(()=>{
        window.scrollTo(0, 0);
        if(edit && location.state?.message){
            setSuccessToastMessage(true);
            Navigate(location.pathname, { replace: true, 
                state: {auction : location.state.auction } });
            setTimeout(() => {
                setSuccessToastMessage(false);
            }, 5000);
        }
        if(edit && auctionData){
            setLoadLots(true);
            getLotDetails();
        }
        if(!auctionData){
            Navigate(`/auctions/${id}/${uid}/lots`)
        }
    },[])

    /*Helper function to upload local images to S3*/
    const uploadImagesToS3 = async (imageData) => {
        if (!imageData?.file) return null;
        
        try {
            const webpImage = await convertToWebP(imageData.file);
            const upload = await Storage.put(`DomainName/Auctions/lots/images/${uuid()}/${sanitizeFileName(webpImage.name)}`, webpImage, {
                contentType: webpImage.type,
                serverSideEncryption: 'aws:kms',
                SSEKMSKeyId: config.Storage.kmsKeyId,
            });
            return upload.key;
        } catch (error) {
            console.error('Error uploading image to S3:', error);
            return null;
        }
    };

    /*Helper function to process images and upload to S3*/
    const processImages = async () => {
        const uploadPromises = localImages.map(imageData => uploadImagesToS3(imageData));
        const uploadedImageKeys = await Promise.all(uploadPromises);
        const validImageKeys = uploadedImageKeys.filter(key => key !== null);
        
        return lotData.images.map((image) => {
            if (image.url && image.url.startsWith('blob:')) {
                const localImageIndex = localImages.findIndex(localImg => 
                    localImg.localUrl === image.url
                );
                if (localImageIndex !== -1 && validImageKeys[localImageIndex]) {
                    return { ...image, url: validImageKeys[localImageIndex] };
                }
                return null;
            }
            return image;
        }).filter(Boolean);
    };

    /*Helper function to construct lot payload*/
    const buildLotPayload = (finalImages, isEdit = false) => {
        const basePayload = {
            auction_id: auctionData.auction_id,
            seller_email: email,
            title1: lotData.title1,
            title2: lotData.title2,
            description: lotData.description,
            ...(auctionData.auction_type==="live" ?
                {reserve: lotData.reserve==="" ? 0 : parseInt(lotData.reserve)} : 
                {starting_price: lotData.starting_price==="" ? 0 : parseInt(lotData.starting_price)} ),
            low_estimate: lotData.low_estimate==="" ? 0 : parseInt(lotData.low_estimate),
            high_estimate: lotData.high_estimate==="" ? 0 : parseInt(lotData.high_estimate),
            shipping_details: lotData.shipping_details,
            tags: lotData.tags,
            images: finalImages,
        };
        
        if (isEdit) {
            basePayload.lot_number = parseInt(lotNumber);
        } else {
            basePayload.current_bid = 0;
        }
        
        return basePayload;
    };

    /*Helper function to delete old S3 images*/
    const deleteOldS3Images = async () => {
        try {
            if (!oldS3Images || oldS3Images.length === 0) return;
    
            const deletePromises = oldS3Images.map((imageKey) => {
                const body = { key: imageKey };
                return dataService.deleteImageFromS3(body);
            });
    
            await Promise.all(deletePromises);
    
        } catch (error) {
            console.error("Error deleting old S3 images:", error);
        }
    };

    /**
     * The function `createLothandler` is an asynchronous function that creates a new lot by uploading
     * images to S3 first, then sending a request to the server with the provided lot data.
     */
    const createLothandler=async()=>{
        if (!mandatoryFieldsFilled()) {
            setOpenExitModal(false);
            setErrorMessage('Please fill all mandatory fields.');
            setTimeout(() => {
                setErrorMessage('');
            }, 5000);
            return false;
        }

        setLoading(true);
        try {
            const finalImages = await processImages();

            // Delete orphaned description images from S3
            const orphanedKeys = getOrphanedDescriptionImageKeys(imageTrackerRef.current, lotData.description);
            if (orphanedKeys.length > 0) {
                await Promise.all(orphanedKeys.map(key => dataService.deleteImageFromS3({ key })));
            }
            imageTrackerRef.current.length = 0;

            const body = buildLotPayload(finalImages);
            const response = await dataService.CreateLot(body, auctionData.auction_type=="live");
            setLoading(false);
            if(response.error===false){
                Navigate(`/auctions/${id}/${uid}/lots`, {state : {message: 'Lot successfully created'}})
            }else{
                const isBadRequest = response.message?.response?.status === 400;
                Navigate(`/auctions/${id}/${uid}/lots`, {state : {error: isBadRequest ? response.message?.response?.data?.message : 'Something went wrong, please try again'}})
            }
        } catch (error) {
            console.error('Error in createLothandler:', error);
            setLoading(false);
            Navigate(`/auctions/${id}/${uid}/lots`, {state : {error: 'Something went wrong, please try again'}})
        }
    }

    /**
     * The `editLotHandler` function is an asynchronous function that handles the editing of a lot by
     * uploading images to S3 first, then sending a request to update the lot data.
     */
    const editLotHandler=async()=>{
        if (!mandatoryFieldsFilled()) {
            setOpenExitModal(false);
            setErrorMessage('Please fill all mandatory fields.');
            setTimeout(() => {
                setErrorMessage('');
            }, 5000);
            return false;
        }
        
        setLoading(true);
        
        try {
            const finalImages = await processImages();
            try {
                await deleteOldS3Images();
            } catch (deleteError) {
                console.error('Failed to delete old S3 images:', deleteError);
            }

            // Delete orphaned description images from S3
            const orphanedKeys = getOrphanedDescriptionImageKeys(imageTrackerRef.current, lotData.description);
            if (orphanedKeys.length > 0) {
                await Promise.all(orphanedKeys.map(key => dataService.deleteImageFromS3({ key })));
            }
            imageTrackerRef.current.length = 0;

            // Continue with update despite deletion failure
            const body = buildLotPayload(finalImages, true);
            const response = await dataService.updateLot(body, auctionData.auction_type=="live");
            if(response.error===false){
                setSuccessToastMessage(true);
                getLotDetails();
                setTimeout(() => {
                    setSuccessToastMessage(false);
                }, 5000);
            }else if(response.message?.response?.data.message=="Lot has already been bid"){
                setOpenExitModal(false);
                setErrorMessage("This lot has already got a bid on it – you can't change the starting price.");
                setTimeout(() => {
                    setErrorMessage('');
                }, 4000);
            }else if(response.message?.response?.data.message=="Images are required for lot update."){
                setOpenExitModal(false);
                setErrorMessage("Cannot delete lot image when auction is Published.");
                setTimeout(() => {
                    setErrorMessage('');
                }, 4000);
            }else{
                setOpenExitModal(false);
                const isBadRequest = response.message?.response?.status === 400;
                setErrorMessage(isBadRequest ? response.message?.response?.data?.message : 'Something went wrong, please try again');
                setTimeout(() => {
                    setErrorMessage('');
                }, 4000);
            }
        } catch (error) {
            console.error('Error in editLotHandler:', error);
            setOpenExitModal(false);
            setErrorMessage('Something went wrong, please try again');
            setTimeout(() => {
                setErrorMessage('');
            }, 4000);
        } finally{
            setLoading(false);
        }
    }

    const handlePrevClick = () => {
        Navigate(`/auctions/${id}/${auctionData.auction_id}/lots/${lotNavigation.prev}`,
            {state : {auction : auctionData } })
    }

    const handleNextClick = () => {
        Navigate(`/auctions/${id}/${auctionData.auction_id}/lots/${lotNavigation.next}`,
            {state : {auction : auctionData } })
    }

    const getButtonText = () => {
        switch(openExitModal) {
        case 'back': return 'Back to lot list view';
        case 'prev': return 'Go to previous lot';
        case 'next': return 'Go to next lot';
        default: return 'Continue';
        }
    };
    
    const handleNavigation = () => {
        switch(openExitModal) {
        case 'back':
            Navigate(`/auctions/${id}/${uid}/lots${location.state?.search || ''}`);
            break;
        case 'prev':
            handlePrevClick();
            break;
        case 'next':
            handleNextClick();
            break;
        }
    };

    // Check if mandatory fields are filled for create mode
    const mandatoryFieldsFilled = () => {
        const isPublishedOrAcceptingBids = auctionData?.status === 'Published' || auctionData?.status === 'Accepting bids';
        const imageRequired = edit ? (isPublishedOrAcceptingBids ? lotData.images.length > 0 : true) : lotData.images.length > 0;
        const baseFields = lotData.title1 && lotData.description && imageRequired;
        const priceField = auctionData?.auction_type === 'live' ? lotData.reserve : lotData.starting_price;
        const estimateValid = (lotData.low_estimate === "" && lotData.high_estimate === "") || 
                             (lotData.low_estimate !== "" && lotData.high_estimate !== "");
        
        return baseFields && priceField && estimateValid;
    };

    return(<>
        {auctionData && <div className="bg-[#F4F4F5]">
            {/* <!-- Navbar content --> */}
            <Header priceError={priceError}
                setPriceError={setPriceError}
                auctionData={auctionData}
                setLotData={setLotData}
                lotData={lotData} 
                loading={loading || descriptionUploading}
                isBanner={isBanner} 
                handlePrevClick={handlePrevClick}
                handleNextClick={handleNextClick}
                lotNavigation={lotNavigation}
                setIsBanner={setIsBanner}
                edit={edit} lotNumber={lotNumber}
                createLothandler={edit ? editLotHandler : createLothandler}
                setOpenExitModal={setOpenExitModal}
                mandatoryFieldsFilled={mandatoryFieldsFilled}
                hasChanges={hasChanges}
                text={text} setText={setText}
                localImages={localImages} setLocalImages={setLocalImages}
                oldS3Images={oldS3Images} setOldS3Images={setOldS3Images} />
            {/* <!-- main content --> */}
            <div className={`w-full flex ${isBanner ? 'h-[calc(100vh-68px)]' : 'mt-[45px] max-h-[calc(100vh-113px)]'} `}>
                {/* <!-- preview section --> */}
                {auctionData.auction_type=="live" ? 
                    <LiveLotPreview lotData={lotData} auctionData={auctionData} 
                        successToastMessage={successToastMessage}
                        errorMessage={errorMessage} /> : 
                    <PreviewSection lotData={lotData} auctionData={auctionData} 
                        successToastMessage={successToastMessage}
                        errorMessage={errorMessage} />}
                {/* <!-- setup auction desktop view --> */}
                <div id='web-panel-configuration' 
                    className={`xl:w-[26%] lg:w-[30%] md:w-[40%] md:block hidden border-l relative
                        ${isBanner ? 'h-[calc(100vh-68px)]' : 'max-h-[calc(100vh-113px)]' }
                        border-[#D4D4D8] bg-[#fff] ${loading ? 'overflow-hidden' : 'overflow-y-scroll'} customScrollbar`}>
                    {auctionData.auction_type=="live" ? 
                        <LiveLotSetup quillModules={quillModules.current} lotData={lotData} text={text} setText={setText}
                            auctionData={auctionData}
                            setLotData={setLotData}
                            priceError={priceError}
                            setPriceError={setPriceError} edit={edit}
                            localImages={localImages} setLocalImages={setLocalImages}
                            oldS3Images={oldS3Images} setOldS3Images={setOldS3Images}
                            descriptionImageError={descriptionImageError} />
                        :
                        <SetupSection quillModules={quillModules.current} lotData={lotData} text={text} setText={setText}
                            auctionData={auctionData}
                            setLotData={setLotData}
                            priceError={priceError}
                            setPriceError={setPriceError} edit={edit}
                            localImages={localImages} setLocalImages={setLocalImages}
                            oldS3Images={oldS3Images} setOldS3Images={setOldS3Images}
                            descriptionImageError={descriptionImageError} />
                    }
                    {loading && (
                        <div className="fixed top-0 bottom-0 right-0 w-[26%] xl:w-[26%] lg:w-[30%] md:w-[40%] bg-white/70 flex items-center justify-center z-[99] pointer-events-auto">
                            <Triangle
                                height="60"
                                width="60"
                                color="#000"
                                ariaLabel="triangle-loading"
                                visible={true}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>}
        {loadLots && (
            <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
                <Triangle
                    height="80"
                    width="80"
                    color="#ffff"
                    ariaLabel="triangle-loading"
                    visible={true}
                />
            </div>
        )}
        <ExitModal 
            isOpen={!!openExitModal} 
            setIsOpen={setOpenExitModal} 
            handleSave={edit ? editLotHandler : createLothandler}
            handleNavigation={handleNavigation}
            getButtonText={getButtonText}
            loading={loading} />
    </>
    );
}